import { ParseResult, parse } from 'papaparse';

export const createCsvParser = <T>() => {
  return (files: File[]) =>
    new Promise<ParseResult<T>>((resolve, reject) => {
      parse<T>(files[0], {
        header: true,
        transformHeader: (header) => header.toLowerCase().replace(/\s/g, ''),
        skipEmptyLines: 'greedy',
        complete: (results) => {
          resolve(results);
        },
        error: reject,
      });
    });
};
